export default "__VITE_ASSET__vAqLBTIv__"